import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { City, CityStatus, CityUpsert, PagedResponse } from '../types'

/** Nested taban yolu — tüm şehir uçları ülke kapsamındadır. */
const base = (countryId: number) => `/management/countries/${countryId}/cities`

/** Seçili ülkenin silinmemiş şehirleri (ada göre sıralı). Tek çağrı (size=1000); tabloda istemci sayfalanır. */
export async function getCities(countryId: number): Promise<PagedResponse<City>> {
  const { data } = await apiClient.get<PagedResponse<City>>(base(countryId), {
    params: { page: 0, size: 1000 },
  })
  return data
}

/** Yeni şehir oluştur — seçili ülkeye bağlı (201 → oluşturulan kayıt). */
export async function createCity(countryId: number, body: CityUpsert): Promise<City> {
  const { data } = await apiClient.post<City>(base(countryId), body)
  return data
}

/** Şehri güncelle (ad; optimistic lock modDate zorunlu). Ülke değişmez. */
export async function updateCity(
  countryId: number,
  cityId: number,
  body: CityUpsert,
): Promise<City> {
  const { data } = await apiClient.put<City>(`${base(countryId)}/${cityId}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeCityStatus(
  countryId: number,
  cityId: number,
  body: CityStatus,
): Promise<City> {
  const { data } = await apiClient.put<City>(`${base(countryId)}/${cityId}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteCity(countryId: number, cityId: number): Promise<void> {
  await apiClient.delete(`${base(countryId)}/${cityId}`)
}

/**
 * Seçili ülkenin şehir listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportCities(countryId: number): Promise<void> {
  await downloadXlsx(`${base(countryId)}/export`, {}, 'sehirler.xlsx')
}
